import { render } from "./KaradList.vue?vue&type=template&id=32f37c5a&scoped=true"
import script from "./KaradList.vue?vue&type=script&lang=js"
export * from "./KaradList.vue?vue&type=script&lang=js"

import "./KaradList.vue?vue&type=style&index=0&id=32f37c5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f37c5a"]])

export default __exports__